import { colors } from "../../../../../themes/variables"

export const getStyles = (token) => ({
  card: {
    position: "relative",
    border: `1px solid ${colors.lines}`
  },
  cardBody: {
    paddingRight: token.paddingMD,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  imageContainer: {
    width: 80,
    height: 80,
    borderRadius: `${token.borderRadiusLG}px 0 0 ${token.borderRadiusLG}px`,
    overflow: "hidden",
    backgroundColor: token.colorFillTertiary
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  defaultImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    padding: token.padding,
    backgroundColor: colors.blueSurface
  },
  editButton: {
    width: 30,
    height: 30,
    border: `1px solid ${colors.lines}`,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: `all ${token.motionDurationMid}`,
    "&:hover": {
      borderColor: token.colorPrimary,
      ".anticon": {
        color: token.colorPrimary
      }
    }
  },
  checkbox: {
    width: 24,
    height: 24,
    border: `2px solid ${colors.lines}`,
    borderRadius: token.borderRadiusSM,
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: `all ${token.motionDurationMid}`
  },
  mapElement: {
    "& :fill": "#d92c9e !important"
  }
})
